import { create } from 'zustand';

interface ISkeletonState {
  isScreenLoading: boolean;
  isDrawerLoading: boolean;
  isTableLoading: boolean;
  setScreenLoading: (loading: boolean) => void;
  setDrawerLoading: (loading: boolean) => void;
  setTableLoading: (loading: boolean) => void;
}

export const useSkeletonStore = create<ISkeletonState>((set) => ({
  isScreenLoading: false,
  isDrawerLoading: false,
  isTableLoading: false,
  setScreenLoading: (loading) => set({ isScreenLoading: loading }),
  setDrawerLoading: (loading) => set({ isDrawerLoading: loading }),
  setTableLoading: (loading) => set({ isTableLoading: loading }),
}));
